"use client"

import { useState, useEffect } from "react";
import { Card } from "react-bootstrap";
import { BarChart, Bar, Rectangle, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import XLSX from 'xlsx';
import { toast } from "react-toastify";

import * as myApi from "../Api";

const PaperSection = ({ data }) => {

    const [papers, setPapers] = useState([]);
    const [isDarkMode, setIsDarkMode] = useState(false);

    useEffect(() => {
        const checkDarkMode = () => {
            const htmlElement = document.querySelector("html");
            setIsDarkMode(htmlElement.classList.contains("dark") || localStorage.getItem("theme") === "dark");
        };
        checkDarkMode();
    }, []);

    useEffect(() => {
        // Initialize with dummy data
        const dummy = [
            {
              code: "pm",
              name: 'PM (Paper Mahasiswa)',
              paper: 0,
            },
            {
              code: "pu",
              name: 'PU (Paper Umum)',
              paper: 0,
            }
          ];
        let execData = dummy;

        // If data is available, use it to populate the chart
        if (data && data.type) {
            execData = [];
            Object.keys(data.type).forEach(function (key) {
                execData.push({
                    code: key,
                    name: data.type[key].name,
                    paper: data.type[key].count
                });
            });
        }

        setPapers(execData);
    }, [data]);

    const handleDownload = () => {
        myApi.post('/fetchAllPaperByType').then((res) => {
            let result = res.data

            // Get PM and PU papers from the response
            let pmPapers = result.listPM || [];
            let puPapers = result.listPU || [];

            const wb = XLSX.utils.book_new();

            if (pmPapers.length > 0) {
                const ws1 = XLSX.utils.json_to_sheet(pmPapers);
                XLSX.utils.book_append_sheet(wb, ws1, "PM (Paper Mahasiswa)");
            }

            if (puPapers.length > 0) {
                const ws2 = XLSX.utils.json_to_sheet(puPapers);
                XLSX.utils.book_append_sheet(wb, ws2, "PU (Paper Umum)");
            }

            XLSX.writeFile(wb, "paperlist.xlsx");

        }).catch(error => {
            console.error('Error downloading papers:', error);
            toast('Error downloading papers', { type: "error" });
        })
    }

    return (
        <Card className="border-0">
            <Card.Header as="h5" className={`bg-primary ${isDarkMode ? 'text-white' : 'text-white'}`}>Paper</Card.Header>
            <Card.Body>
                <ResponsiveContainer width="100%" height={400}>
                    <BarChart
                        width={500}
                        height={300}
                        data={papers}
                        margin={{
                            top: 5,
                            right: 0,
                            left: 0,
                            bottom: 5,
                        }}
                    >
                        <CartesianGrid strokeDasharray="3 3" stroke={isDarkMode ? "#444" : "#ccc"} />
                        <XAxis dataKey="name" tick={{ fill: isDarkMode ? "#fff" : "#333" }} />
                        <YAxis tick={{ fill: isDarkMode ? "#fff" : "#333" }} />
                        <Tooltip 
                            contentStyle={{ 
                                backgroundColor: isDarkMode ? "#1a1a1a" : "#fff", 
                                border: isDarkMode ? "1px solid #444" : "1px solid #ccc",
                                color: isDarkMode ? "#fff" : "#333"
                            }} 
                        />
                        <Legend wrapperStyle={{ color: isDarkMode ? "#fff" : "#333" }} />
                        <Bar dataKey="paper" fill="#8884d8" activeBar={<Rectangle fill="pink" stroke="blue" />} />
                    </BarChart>
                </ResponsiveContainer>
            </Card.Body>
            <Card.Footer className="bg-transparent border-0">
                <div className="d-flex justify-content-center">
                    <button className="btn btn-primary" onClick={handleDownload}>
                        <span className="text-white d-flex gap-2 align-items-center">
                            <i className="material-symbols-outlined">cloud_download</i>
                            <span> Save as XLSX</span>
                        </span>
                    </button>
                </div>
            </Card.Footer>
        </Card>
    );
};

export default PaperSection;